import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { fetchPatients, fetchDoctors } from "../Actions";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import PatientsTable from "./tables/PatientsTable";
import * as moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";
import { registerLicense } from "@syncfusion/ej2-base";

registerLicense(
  "ORg4AjUWIQA/Gnt2UVhhQlVFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5RdEVjXntdcHNVQGda;MzExNjY5OUAzMjM0MmUzMDJlMzBFZmo4T0hTeUlZQjB3cjhSVFkvT0tLUDFUVEtMZU9NQXljVHk3dXloYnJ3PQ=="
);

const PatientsDetails = (props) => {
  // console.log(props);
  let date = moment(new Date());
  // const [endDate, setEndDate] = useState(
  //   new Date(date.add(1, "day").valueOf())
  // );
  // const [startDate, setStartDate] = useState(
  //   new Date(date.subtract(1, "month").valueOf())
  // );
  const [data, setData] = useState([]);
  const [oneWeekPressed, setOneWeekPressed] = useState(false);
  const [twoWeekPressed, setTwoWeekPressed] = useState(false);
  const [oneMonthPressed, setOneMonthPressed] = useState(true);
  const [threeMonthPressed, setthreeMonthPressed] = useState(false);
  const [sixMonthPressed, setSixMonthPressed] = useState(false);
  const [searchdata, setSearchData] = useState(false);
  const [dates1, setDates1] = useState("");
  const [dates2, setDates2] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(date.subtract(1, "week").valueOf()),
    endDate: new Date(date.add(7, "day").valueOf()),
  });

  useEffect(() => {
    const startDate1 = moment(dateRange.startDate).format("YYYY-MM-DD");
    const endDate1 = moment(dateRange.endDate).format("YYYY-MM-DD");
    if (dateRange.endDate !== null && dateRange.startDate !== null) {
      // props.fetchPatients(endDate1, startDate1).then(() => setLoading(false));
      setData(
        localStorage.getItem("user") === "admin"
          ? props.doctors.agentId
            ? filtereddata
            : rawdata
          : rawdata
      );
      setDates1(startDate1.toLocaleString());
      setDates2(endDate1.toLocaleString());
    } else {
      // props.fetchPatients("", "").then(() => setLoading(false));
      setDates1(startDate1.toLocaleString());
      setDates2(endDate1.toLocaleString());
    }
    // setLoading(false);
  }, [dateRange.endDate, dateRange.startDate]);

  useEffect(() => {
    if (!searchdata) {
      setData(
        localStorage.getItem("user") === "admin"
          ? props.doctors.agentId
            ? filtereddata
            : rawdata
          : rawdata
      );
    }
  });

  const oneDayHandler = () => {
    setSelectedOption("1day");
    const today = moment().startOf("day").toDate();
    setDateRange({ startDate: today, endDate: today }); // Set start date to today
    // setEndDate(today); // Set end date to today
  };

  const oneYearHandler = () => {
    setSelectedOption("1year");
    const startDate = moment().subtract(1, "year").toDate();
    const endDate = moment().toDate();
    setDateRange({ startDate: startDate, endDate: endDate });
    // setStartDate(startDate); // Set start date 1 year ago
    // setEndDate(endDate); // Set end date to end of this year
  };

  
  const handleRangeSelected = (args) => {
    const startDate1 = args.value[0];
    const endDate1 = args.value[1];

    const startDate2 = moment(startDate1).format("YYYY-MM-DD");
    const endDate2 = moment(endDate1).format("YYYY-MM-DD");
    setDateRange({ startDate: startDate2, endDate: endDate2 });
    setSelectedOption("");
  };
  const handleDateRangePickerRef = (ref) => {
    if (ref && selectedOption === "custom") {
      ref.show();
    }
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);

    if (value === "1week") {
      oneWeekHandler();
      setShowDatePicker(false);
    } else if (value === "1day") {
      oneDayHandler();
      setShowDatePicker(false);
    } else if (value === "1month") {
      oneMonthHandler();
      setShowDatePicker(false);
    } else if (value === "1year") {
      oneYearHandler();
      setShowDatePicker(false);
    } else if (value === "custom") {
      setShowDatePicker(true);
    }
  };

  const oneWeekHandler = () => {
    setOneWeekPressed(true);
    setTwoWeekPressed(false);
    setOneMonthPressed(false);
    setthreeMonthPressed(false);
    setSixMonthPressed(false);

    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    // setStartDate(new Date(newStartdate.subtract(7, "day").valueOf()));
    // setEndDate(new Date(newEnddate.add(1, "day").valueOf()));
    setDateRange({
      startDate: new Date(newStartdate.subtract(7, "day").valueOf()),
      endDate: new Date(newEnddate.add(1, "day").valueOf()),
    });
  };

  const oneMonthHandler = () => {
    setOneWeekPressed(false);
    setTwoWeekPressed(false);
    setOneMonthPressed(true);
    setthreeMonthPressed(false);
    setSixMonthPressed(false);

    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    // setStartDate();
    // setEndDate(new Date(newEnddate.add(1, "day").valueOf()));
    setDateRange({
      startDate: new Date(newStartdate.subtract(1, "month").valueOf()),
      endDate: new Date(newEnddate.add(1, "day").valueOf()),
    });
  };

  const filtereddata = React.useMemo(() => {
    props.patient.patient.filter(function (s) {
      return s.userId === props.doctors.agentId;
    });
  }, [props.patient.patient]);

  // Normal Raw data
  const rawdata = React.useMemo(
    () => props.patient.patient,
    [props.patient.patient]
  );

  const [width, setWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);

  return (
    <div>
      <div className="dashboard">
        <div className="dashboard__content">
          <div className="dateSelection">
            <select
              className="selectDate"
              id="duration"
              value={selectedOption}
              onChange={handleChange}
            >
              <option>Date Range</option>
              <option value="1day">1 Day</option>
              <option value="1week">1 Week</option>
              <option value="1month">1 Month</option>
              <option value="1year">1 Year</option>
              <option value="custom">Custom</option>
            </select>
            {showDatePicker && (
              <div className="dateRangePicker">
                <DateRangePickerComponent
                  id="daterangepicker"
                  placeholder="Select a range"
                  startDate={dateRange.startDate}
                  endDate={dateRange.endDate}
                  showClearButton={false}
                  onChange={handleRangeSelected}
                  ref={(ref) => handleDateRangePickerRef(ref)}
                />
              </div>
            )}
            <div className="dates-container">
              <p className="dates">{moment(dates1).format("DD-MM-YYYY")} </p>
              <p className="dates">to</p>
              <p className="dates">{moment(dates2).format("DD-MM-YYYY")} </p>
            </div>
          </div>
          <PatientsTable
            searchData={data}
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
            propData={data}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  patient: state.patient,
  doctors: state.doctors,
});

export default connect(mapStateToProps, { fetchPatients, fetchDoctors })(
  PatientsDetails
);
